import { FILE_ROOT } from "@config";
import dayjs from "dayjs";
import { API } from "@utils/http/api";
import { allRoutes, whiteRoutes } from "../../router/dynamicRoutes";



/**
 * 图片地址格式化
 * @param {*} rawImg 图片地址
 */

export function formatImg(rawImg) {
    if (rawImg) return FILE_ROOT + rawImg;
    else return "";
}

/**
 * 日期时间格式化
 * @param {*} dateTime 日期时间
 * @param {*} forma  格式类型
 * @returns {string}
 */
export function formatDateTime(dateTime, forma = "YYYY-MM-DD HH:mm") {
    if (!dateTime || dateTime <= 0) return "-";
    return dayjs(dateTime).format(forma);
}

/**
 * 生成字母选项（ABCD...）
 * @param {*} num 数字从0开始
 */
export function creationLetter(num) {
    const ascii = num + 65;

    if (!isNaN(num) && ascii < 65 && ascii >= 91) return "-";
    return String.fromCharCode(ascii);
}

/**
 * 验证是外部链接
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * 格式化货币，保留2位小数
 * @param num 数值(Number或者String)
 * @return 金额格式的字符串,如'1,234,567.45'
 * @type String
 */
export function formatCurrency(num) {
    if (!num) return 0;

    num = num.toString().replace(/\$|\,/g, "");
    if (isNaN(num)) {
        num = "0";
    }

    let sign = num == (num = Math.abs(num)); //数字是否为正负数  Math.abs() 返回参数的绝对值
    num = Math.floor(num * 100 + 0.50000000001); //返回小于等于num*100+0.50000000001的最大整数:
    let cents = num % 100; //小数位数
    num = Math.floor(num / 100).toString(); //整数位数
    if (cents < 10) {
        cents = "0" + cents; //小数位补0
    }
    for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
        // 货币，三位数字一间隔
        num =
            num.substring(0, num.length - (4 * i + 3)) +
            "," +
            num.substring(num.length - (4 * i + 3));
    }
    return (sign ? "" : "-") + num + "." + cents;
}


/* 返回 存储到数据库 后台的数据*100 */
export function formatMaxNum(num){
    if (!num) return 0;
    // num = num.toString().replace(/\$|\,/g, "");
    if (isNaN(num)) {
        num = "0";
    }

    return num*100
}
export function formatMinNum(num){
    if (!num) return 0;
    return num/100
}



/**
 * 验证密码
 * @param {*} password 密码
 */
export function passwordValidation(password) {
    var reg = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[!#@*&.])[a-zA-Z\d!#@*&.]{8,50}$/;

    if (reg.test(password)) return true;
    else return false;
}

/**
 *动态路由过滤
 * @param {Array} userRouter  后台返回的用户权限路由
 * @returns {Array} 过滤后的路由
 */
export async function recursionRouter(userRouter = []) {
    let addRoutes = []; //过滤后的路由

    const { data: resData } = await API.get("/menus");

    if (resData.result != 200) return;
    resData.data.forEach((item) => {
        let existRoutes = allRoutes.find((a) => a.name == item.webUrl);
        if (existRoutes) addRoutes.push(existRoutes);
    });

    addRoutes.forEach((item) => {
        const children = [];
        item.children.forEach((son) => {
            let existRoutes = resData.data.find((a) => son.name == a.webUrl);
            if (existRoutes) children.push(son);
        });
        item.children = children;
    });

    //追加白名单
    addRoutes.push(...whiteRoutes);

    return addRoutes;
}




/**
 * 封装判空null,undefined
 * @param obj 数值(Number或者String)
 * @return obj,如'{ww:'dd'}'  返回true false
 */
export const isEmpty = (obj) => {
    if (typeof obj == "undefined" || obj == null || obj == "" || obj == "null") {
        return true;
    } else {
        return false;
    }
};

/* 封装三目运算  页面判空不显示   专用于页面显示不做js逻辑判定  */
export const emptyShow = (obj) => {
    if (typeof obj == "undefined" || obj == null || obj == "" || obj == "null") {
        return '' ;
    } else {
        return obj;
    }
};
